import {gameStages, units, unitTypes, actionColors, groundTypes, objectives} from './GameVariables';
import { arraysMatch } from './Utils';
const config = require('../config.js');

function log(...args){
    if(!config.production) {
        console.log(...args);
    }
}

export default function() {
    let that = this;
    /* Game Getters Section */
    this.getStarterUnits = function(unitLoadout, team) {
        let loadout = [];
        for(let item of unitLoadout){
            loadout.push({unit: that.getUnitById(item.unit)(team), count: item.count});
        }
        return loadout;
    }
    this.getUnitById = function(unitId) {
        return Object.values(units).find(unit => unit().id === unitId);
    }
    this.getTileByLocation = function(xPos, yPos) {
        return that.tileMap[yPos][xPos];
    }
    this.getUnitByLocation = function(xPos, yPos) {
        return that.getTileByLocation(xPos, yPos).unit
    }
    this.tileMapFind = function(validator){
        for(let i = this.lowerHalfIndex; i < this.tileMap.length; i++){
            for(let tile of this.tileMap[i]){
                if(validator(tile)){
                    return tile;
                }
            }
        }
    }
    this.tileMapFilter = function(validator){
        const response = [];
        for(let i = this.lowerHalfIndex; i < this.tileMap.length; i++){
            for(let tile of this.tileMap[i]){
                if(validator(tile)){
                    response.push(tile);
                }
            }
        }
        return response;
    }
    /* Board Manipulation Section */
    this.showPointer = function(xPos, yPos, pointerColor, update=true) {
        let tile = that.getTileByLocation(xPos, yPos);
        tile.pointer.color = pointerColor;
        tile.pointer.enabled = true;
        if(update){
            that.updateTileMap();
        }
    }
    this.showPointers = function(pointerList, pointerColor){
        pointerList.forEach(pointer => {
            that.showPointer(...pointer, pointerColor, false);
        });
        that.updateTileMap();
    }
    this.hidePointer = function(xPos, yPos) {
        let tile = that.getTileByLocation(xPos, yPos);
        tile.pointer.color = 'none';
        tile.pointer.enabled = false;
        that.updateTileMap();
    }
    this.hideAllPointers = function() {
        for(let y = 0; y < that.tileMap.length; y++){
            for(let x = 0; x < that.tileMap[y].length; x++){
                let tile = that.getTileByLocation(x, y);
                if (tile.pointer.enabled){
                   that.hidePointer(x, y);
                }
            }
        }
        that.updateTileMap();
    }
    this.placeUnit = function(xPos, yPos, unit) {
        that.tileMap[yPos][xPos].unit = unit;
        that.updateTileMap();
    }
    this.hideUnit = function(xPos, yPos) {
        that.tileMap[yPos][xPos].unit = null;
        that.updateTileMap();
    }
    this.updateTileMap = function() {
        that.updaters.tileMap(that.tileMap);
    }
    /* Game Updaters & Setters Section */
    this.updateUnitSelector = function() {
        that.updaters.unitSelector(that.currentPlacingUnits);
    }
    this.updateUnloadUnits = function(unloadUnits) {
        that.updaters.unloadUnits(unloadUnits);
    }
    this.updateGameStatus = function() {
        const gameStatus = {
            gameStage: that.gameStage,
            turnPlayer: that.turnPlayer,
            turnNumber: that.turnNumber
        };
        that.updaters.gameStatus(gameStatus);
        that.updateObjective();
    }
    this.updateObjective = function(objective) {
        let result;
        if(objective){
            result = objective;
        }
        else{
            if(this.gameStage === gameStages.prepStage){
                if(this.allUnitsPlaced()){
                    result = objectives.prep2;
                }
                else{
                    result = objectives.prep1;
                }
            }
            else{
                if(this.turnPlayer === this.localTeam){
                    result = objectives.gameSelf1;
                }
                else {
                    result = objectives.gameOp1;
                }
            }
        }
        this.objective = result;
        this.updaters.objective(result); 
    }
    this.updateHoverUnit = function() {
        const unitCounter = that.currentPlacingUnits.find(val => val.unit.id === that.placingUnit);
        if(unitCounter.count > 0){
            const unit = {...unitCounter.unit};
            unit.isVirtual = true;
            this.hoverUnit = unit;
        }
        else{
            this.hoverUnit = null;
        }
        for(let y = this.lowerHalfIndex; y < this.tileMap.length; y++){
            for(let x = 0; x < this.tileMap.length; x++){
                const tile = this.getTileByLocation(x, y);
                if(this.allowHoverUnits && this.hoverUnit && this.hoverUnit.prepPlacements.includes(tile.groundType)){
                    tile.showHoverUnit = true;
                }
                else{
                    tile.showHoverUnit = false;
                }
            }
        }
        this.updateTileMap();
    }
    this.setUnloadingUnit = function(unitIndex){
        const vehicle = that.getUnitByLocation(...that.selectedUnitCords);
        const unit = vehicle.unitsCurrentlyLoaded[unitIndex];
        if(unitIndex == -1){
            that.virtualUnit = null;
        }
        else if(unit){
            that.virtualUnit = unit;
        }
        that.virtualUnitId = unitIndex;
        that.disableSelectMode(true);
        that.enableSelectMode(...that.selectedUnitCords);
    };
    this.setPlacingUnit = function(unitId) {
        that.placingUnit = unitId;
        that.updaters.placingUnit(unitId);
        that.updateHoverUnit();
        that.savePrepState();
    }
    this.cycleUnitSelector = function(steps) {
        const currentIndex = that.currentPlacingUnits.findIndex(val =>  val.unit.id === that.placingUnit);
        if(currentIndex !== -1){
            let newIndex = currentIndex + steps;
            if(newIndex > that.currentPlacingUnits.length - 1){
                newIndex = 0;
            }
            else if(newIndex < 0){
                newIndex = that.currentPlacingUnits.length - 1;
            }
            that.setPlacingUnit(that.currentPlacingUnits[newIndex].unit.id);
        }
    }
    this.autoJump = function() {
        // This function cycles unit selector until it finds a unit which can be placed.
        // Then, it sets the placing unit to the next available unit.
        let index = that.currentPlacingUnits.findIndex(val =>  val.unit.id === that.placingUnit);
        let result;
        if(index === that.unitLoadout.length - 1){
            index = 0;
        }
        let foundAfter = false;
        let entry;
        for(let i = index + 1; i < this.unitLoadout.length; i++){
            entry = this.currentPlacingUnits[i];
            if(entry.count > 0){
                result = entry.unit.id;
                foundAfter = true;
                break;
            }
        }
        if(!foundAfter){
            for(let i = 0; i < index; i++){
                entry = this.currentPlacingUnits[i];
                if(entry.count > 0){
                    result = entry.unit.id;
                    break;
                }
            }
        }
        if(result){
            this.setPlacingUnit(result);
        }
    }
    this.toggleHoverUnits = function() { 
        this.allowHoverUnits = !this.allowHoverUnits;
        this.updateHoverUnit();
        this.savePrepState();
    }
    this.toggleAutoJump = function() {
        this.allowAutoJump = !this.allowAutoJump;
        this.savePrepState();
    }
    /* Vehicles Section - Handling vehicles logic */
    this.getVehicleModifiers = function(unitList){
        if(!Array.isArray(unitList)){
            unitList = [unitList];
        }
        const modifiers = [];
        const getModifier = function(by, name) {
            return modifiers.find(val => val.by === by && val.name === name);
        }
        const setModifier = function(by, name, count) {
            const modifier = getModifier(by, name);
            if(modifier){
                modifier.count = count;
            }
            else{
                modifiers.push({by, name, count});
            }
        }
        const updateModifier = function(by, name, manipulator) {
            const modifier = getModifier(by, name);
            if(modifier){
                modifier.count += manipulator;
            }
            else{
                modifiers.push({by, name, count: manipulator});
            }
        }
        for(let unit of unitList){
            if (unit.isCarryingFlag){
                updateModifier('type', 'troop', 1);
            }
            if (unit.isVehicle){
                if(unit.type === 'boat'){
                    setModifier('type', 'boat', 1);
                }
                else{
                    updateModifier('id', unit.id, 1);
                }
                for(let loadedUnit in unit.unitsCurrentlyLoaded){
                    updateModifier('type', loadedUnit.type, 1);
                }
            }
            else{
                updateModifier('type', unit.type, 1);
            }
        }
        return modifiers;
    }
    this.countUnitsOnVehicle = function(vehicle) {
        let count = 0;
        for(let unit of vehicle.unitsCurrentlyLoaded){
            if(unit.isVehicle){
                count += that.countUnitsOnVehicle(unit) + 1;
            }
            else{
                count++;
            }
        }
        return count;
    }
    this.vehicleCanLoadUnit = function(vehicle, unit) {
        /* This function checks if a unit can be loaded into a jet or a boat. */
        // If a vehicle tries to enter another vehicle, all of it's units will be loaded on the carrier.
        if(unit.isCarryingFlag && !vehicle.canCarryFlag){
            return false;
        }
        const vehicleModifiers = that.getVehicleModifiers(vehicle.unitsCurrentlyLoaded);
        let unitModifiers;
        if(unit.isVehicle){
            const unitClone = {...unit};
            unitClone.unitsCurrentlyLoaded = [];
            unitModifiers = that.getVehicleModifiers([unitClone].concat(unit.unitsCurrentlyLoaded));
        }
        else{
            unitModifiers = that.getVehicleModifiers(unit);
        }
        const modifiers = [unitModifiers, vehicleModifiers];

        const unitMatch = vehicle.capacity.find(val => {
            return (val.by === 'type' && val.name === unit.type) || (val.by === 'id' && val.name === unit.id);
        });
        if(!unitMatch){
            return false;
        }
        for(let capacity of vehicle.capacity){
            let count = capacity.count;
            for(let modifierList of modifiers){
                const modifier = modifierList.find(val => capacity.by === val.by && capacity.name === val.name);
                if(modifier){
                    count -= modifier.count;
                }
            }
            if(count < 0){
                return false;
            }
        }
        return true;
    }
    this.removeUnitFromVehicle = function(vehicleXpos, vehicleYpos, unitId) {
        const vehicle = that.getUnitByLocation(vehicleXpos, vehicleYpos);
        const unit = vehicle.unitsCurrentlyLoaded ? vehicle.unitsCurrentlyLoaded[unitId] : null;
        let flag = false;
        if(unit){
            // If the unit to unload exist
            if(vehicle.isVehicle || (vehicle.type === 'troop' && vehicle.isCarryingFlag)){
                // If the unit is a vehicle or a troop carrying flag
                if(unit.isCarryingFlag || unit.id === 'flag'){
                    // If the unit is carrying flag or the flag itself
                    // The vehicle is no longer carrying flag
                    vehicle.isCarryingFlag = false;
                }
                vehicle.unitsCurrentlyLoaded.splice(unitId, 1);
                flag = true;
            }
        }
        return flag;
    }
    /* Game Logic Section */
    that.detectMoveType = function(oldXpos, oldYpos, newXpos, newYpos) {
        const tile = that.getTileByLocation(oldXpos, oldYpos);
        let unit = tile.unit;

        const targetTile = that.getTileByLocation(newXpos, newYpos);
        const targetUnit = targetTile.unit;
        if(that.virtualUnit){
            unit = that.virtualUnit;
        }

        if(targetUnit && targetUnit.team !== unit.team && targetUnit.type === 'troop' && that.virtualUnit && unit.id === 'flag'){
            return 'load';
        }
        else if(targetUnit && targetUnit.team === unit.team && targetUnit.isVehicle && that.vehicleCanLoadUnit(targetUnit, unit)){
            // If the target unit is a friendly vehicle and the unit can be loaded into it
            return 'load';
        }
        else if(unit.moveOn.includes(targetTile.groundType)){
            // If the unit can possibly step on the target ground type
            if(targetUnit){
                // If target tile isn't empty
                if(targetUnit.team !== unit.team && !unit.static){
                    // If an enemy is the target
                    if((tile.groundType === targetTile.groundType || unit.type === 'jet') && !that.virtualUnit){
                        // If both tiles are land or sea (units can't attack from sea to land and vice versa)
                        return 'attack';
                    }
                }
            }
            else if(!unit.static && !that.virtualUnit){
                // If the tile is empty, the unit can move there
                return 'move';
            }
            else if(that.virtualUnit){
                return 'unload';
            }
        }
    }
    this.renderSelectModeMoves = function() {
        for(let move of that.selectModeMoves){
            this.showPointer(...move.cords, actionColors[move.action]);
        }
    }
    this.enableSelectMode = function(xPos, yPos) {
        const breakMoveTypes = ['attack', 'load', undefined];
        let moveType;

        const jetMovement = function(xPos, yPos, targetXpos, targetYpos){
            moveType = that.detectMoveType(xPos, yPos, targetXpos, targetYpos);
            if(moveType){
                that.selectModeMoves.push({cords: [targetXpos, targetYpos], action: moveType});
            }
            if(breakMoveTypes.includes(moveType)){
                return true;
            }
            return false;
        }
        const tile = that.getTileByLocation(xPos, yPos);
        let unit = tile.unit;
        if((unit.type === 'troop' && unit.isCarryingFlag) || unit.isVehicle){
            that.updateUnloadUnits(unit.unitsCurrentlyLoaded);
        }
        if(that.virtualUnit){
            unit = that.virtualUnit;
        }

        if(unit.type !== unitTypes.jet || that.virtualUnit){
            const cordsArr = [
                [xPos + 1, yPos],
                [xPos - 1, yPos],
                [xPos, yPos + 1],
                [xPos, yPos - 1],
            ];
            for(let cords of cordsArr){
                if(cords[0] >= 0 && cords[0] < that.tileMap.length && cords[1] >= 0 && cords[1] < that.tileMap.length){
                    moveType = that.detectMoveType(xPos, yPos, ...cords);
                    if(moveType){
                        that.selectModeMoves.push({cords: cords, action: moveType});
                    }
                }
            }
        }
        else{
            let targetXpos = xPos;
            let targetYpos = yPos;
            let breakSignal = false;
            for(let i = xPos; i < that.tileMap.length - 1; i++){
                targetXpos = i + 1;
                breakSignal = jetMovement(xPos, yPos, targetXpos, targetYpos);
                if(breakSignal){
                    break;
                }
            }
            for(let i = xPos; i > 0; i--){
                targetXpos = i - 1;
                breakSignal = jetMovement(xPos, yPos, targetXpos, targetYpos);
                if(breakSignal){
                    break;
                }
            }
            targetXpos = xPos;
            for(let i = yPos; i < that.tileMap.length - 1; i++){
                targetYpos = i + 1;
                breakSignal = jetMovement(xPos, yPos, targetXpos, targetYpos);
                if(breakSignal){
                    break;
                }
            }
            for(let i = yPos; i > 0; i--){
                targetYpos = i - 1;
                breakSignal = jetMovement(xPos, yPos, targetXpos, targetYpos);
                if(breakSignal){
                    break;
                }
            }
        }

        if(that.selectModeMoves.length > 0 || unit.isVehicle || that.virtualUnit){
            that.renderSelectModeMoves();
            that.selectedUnitCords = [xPos, yPos];
            that.selectMode = true;
            that.updaters.selectMode(that.selectMode);
        }
    }
    this.disableSelectMode = function(keepVirtualUnit=false) {
        that.selectModeMoves = [];
        that.hideAllPointers();
        that.selectMode = false;
        if(!keepVirtualUnit){
            that.virtualUnit = null;
            that.virtualUnitId = -1;
        }
        that.updaters.selectMode(that.selectMode);
    }
    this.addToDeadHall = function (unit){
        // Dead hall is built from unit/count pairs
        const deadHall = unit.team === 'red' ? that.redDeadHall : that.blueDeadHall;
        const unitCounter = deadHall.find(val => val.unit.id === unit.id);
        if(unitCounter) {
            unitCounter.count++;
        }
        else {
            deadHall.push({unit: that.getUnitById(unit.id)(), count: 1});
        }
        if(unit.team === 'red') {
            that.redDeadHall = deadHall;
        }
        else {
            that.blueDeadHall = deadHall;
        }
        const updater = that.updaters.deadHall;
        if(updater){
            updater(unit.team, deadHall);
        }
    }
    this.killUnit = function(unitXpos, unitYpos) {
        let tile, unit;
        if(that.virtualUnit){
            unit = that.virtualUnit;
        }
        else{
            tile = that.getTileByLocation(unitXpos, unitYpos);
            unit = tile.unit;
            that.hideUnit(unitXpos, unitYpos);
        }
        if(unit.isVehicle){
            for(let loadedUnit of unit.unitsCurrentlyLoaded){
                that.virtualUnit = loadedUnit;
                this.killUnit();
            }
        }
        if(tile && unit.isCarryingFlag && groundTypes.ground.includes(tile.groundType)){
            tile.unit = unit.unitsCurrentlyLoaded.find(val => val.id === 'flag');
        }
        that.addToDeadHall(unit);
    }
    this.moveUnit = function (oldXpos, oldYpos, newXpos, newYpos) {
        const unit = that.getUnitByLocation(oldXpos, oldYpos);
        that.hideUnit(oldXpos, oldYpos);
        that.placeUnit(newXpos, newYpos, unit)
    }
    this.loadUnit = function(unitXpos, unitYpos, vehicleXpos, vehicleYpos) {
        let unit = that.getUnitByLocation(unitXpos, unitYpos);
        if(that.virtualUnit){
            unit = that.virtualUnit;
        }
        const vehicle = that.getUnitByLocation(vehicleXpos, vehicleYpos);

        const moveUnitToVehicle = function(unitToLoad) {
            if(!that.allowNestedVehicles && unitToLoad.isVehicle){
                for(let loadedUnit of unitToLoad.unitsCurrentlyLoaded){
                    vehicle.unitsCurrentlyLoaded.push(loadedUnit);
                }
                unitToLoad.unitsCurrentlyLoaded = [];
                vehicle.isCarryingFlag = unitToLoad.isCarryingFlag;
                unitToLoad.isCarryingFlag = false;
            }
            vehicle.unitsCurrentlyLoaded.push(unitToLoad);
        }

        if(unit && vehicle){
            if(unit.type === 'flag' && vehicle.type === 'troop' && unit.team !== vehicle.team){
                vehicle.isCarryingFlag = true;
                moveUnitToVehicle(unit);
                that.removeUnitFromVehicle(unitXpos, unitYpos, that.virtualUnitId);
            }
            else if(vehicle.isVehicle && that.vehicleCanLoadUnit(vehicle, unit)){
                moveUnitToVehicle(unit);
                if(unit.isCarryingFlag){
                    vehicle.isCarryingFlag = true;
                }
                if(that.virtualUnit){
                    that.removeUnitFromVehicle(unitXpos, unitYpos, that.virtualUnitId);
                }
                else{
                    that.hideUnit(unitXpos, unitYpos);
                }
            }
        }
    }
    this.unloadUnit = function(vehicleXpos, vehicleYpos, tileXpos, tileYpos) {
        const unit = that.virtualUnit;
        const removed = that.removeUnitFromVehicle(vehicleXpos, vehicleYpos, that.virtualUnitId);
        if(removed){
            that.virtualUnit = null;
            that.virtualUnitId = -1;
            that.placeUnit(tileXpos, tileYpos, unit);
        }
    }
    this.declareWinner = function(winner) {
        alert(`Team ${winner} wins!`);
    }
    /* Validation Section */
    this.allUnitsPlaced = function() {
        for(let entry of this.currentPlacingUnits){
            if(entry.count > 0){
                return false;
            }
        }
        return true;
    }
    this.scanTileNeighbors = function(tileXpos, tileYpos) {
        /* This function scans the 4 tiles around the tile selected and returns a list of all the close tile that are solid land and free of bombs. */
        const neighborReachableTiles = [];
        let newXpos, newYpos;
        const addToNeighbors = (tileXpos, tileYpos) => {
            const tile = that.getTileByLocation(tileXpos, tileYpos);
            if(tile.groundType === 'l' && !(tile.unit && tile.unit.type === unitTypes.bomb && tile.unit.team === that.localTeam)){
                neighborReachableTiles.push([tileXpos, tileYpos]);
            }
        }
        if(tileXpos > 0){
            newXpos = tileXpos + 1;
            newYpos = tileYpos;
            addToNeighbors(newXpos, newYpos);
        }
        if(tileXpos < this.tileMap.length){
            newXpos = tileXpos - 1;
            newYpos = tileYpos;
            addToNeighbors(newXpos, newYpos);
        }
        if(tileYpos > 0){
            newXpos = tileXpos;
            newYpos = tileYpos + 1;
            addToNeighbors(newXpos, newYpos);
        }
        if(tileYpos < this.tileMap.length){
            newXpos = tileXpos;
            newYpos = tileYpos - 1;
            addToNeighbors(newXpos, newYpos);
        }
        return neighborReachableTiles;
    }
    this.getReachableTiles = function(tileXpos, tileYpos) {
        /* This function returns the number of "reachable" tiles from a specific tiles - that means, is the tile is blockaded by bombs. */
        const reachableTiles = [];
        let tilesToScan = this.scanTileNeighbors(tileXpos, tileYpos);
        let tempTilesToScan = [];
        let scanComplete;
        // Keep scanning until there are no more tiles to scan
        while (!scanComplete){
            // Looping through every index in tilesToScan, checking if the tile has already been scanned
            scanComplete = true;
            for(let i = 0; i < tilesToScan.length; i++){
                let tileAlreadyScanned = false;
                const currentXpos = tilesToScan[i][0];
                const currentYpos = tilesToScan[i][1];
                for(let j = 0; j < reachableTiles.length; j++){
                    if(reachableTiles[j][0] == currentXpos && reachableTiles[j][1] == currentYpos){
                        tileAlreadyScanned = true;
                        break;
                    }
                }
                if (!tileAlreadyScanned){
                    scanComplete = false;
                    reachableTiles.push([currentXpos, currentYpos]);
                    tempTilesToScan = tempTilesToScan.concat(this.scanTileNeighbors(currentXpos, currentYpos));
                }
            }
            tilesToScan = tempTilesToScan;
        }
        return reachableTiles;
    }
    this.locateFlagTile = function() {
        return this.tileMapFind(tile => tile.unit && tile.unit.id === 'flag' && tile.unit.team && tile.unit.team === this.localTeam);
    }
    this.showValidatePointers = function(tileList, tileToHide) {
        const pointerList = [];
        tileList.forEach((tile) => {
            if(tile.cords){
                pointerList.push(tile.cords);
            }
            else{
                pointerList.push(tile);
            }
        });
        this.showPointers(pointerList, 'red');
        if(tileToHide){
            this.hidePointer(...tileToHide);
        }
        clearTimeout(this.validatorTimeout);
        this.validatorTimeout = setTimeout(() => {
            that.hideAllPointers();
        }, 3000);
    }
    this.validateFlagLocation = function(flagTile, showBlockage=true) {
        /* This function checks if the flag is blockaded. */
        if(flagTile){
            const freeTiles = this.getReachableTiles(...flagTile.cords);
            if (freeTiles.length > this.flagBlockageLimit){
                return true;
            }
            if(showBlockage){
                if(freeTiles.length === 0){
                    freeTiles.push(flagTile.cords);
                    this.showValidatePointers(freeTiles);
                }
                else{
                    this.showValidatePointers(freeTiles, flagTile.cords);
                }
            }
        }
        return false;
    }
    this.validateLoadout = function(showResult=false) {
        // In order to validate unit positions, two conditions need to be met:
        // 1. Player's island populates a maximum of 3 units on top
        // 2. Player's flag is not blockaded (surrounded by bombs)
        const response = {accepted: false, message: 'Unit loadout is validated!'};
        const flagTile = this.locateFlagTile();
        const islandTiles =  this.tileMapFilter(tile => ['1', '2'].includes(tile.groundType));
        const populatedIslands = islandTiles.filter(tile => tile.unit).length;
        if(flagTile){
            if(this.validateFlagLocation(flagTile)){
                if(populatedIslands > 3){
                    response.message = 'Please place max of 3 units on your island';
                    this.showValidatePointers(islandTiles);
                }
                else if(this.allUnitsPlaced()){
                    response.accepted = true;
                }
                else{
                    response.message = 'Flag position is valid. Place all your units for further validation.';
                }
            }
            else{
                response.message = 'Please make sure your flag is not blockaded';
            }
        }
        else{
            response.message = 'Please place your flag in order to validate';
        }
        if(response.accepted){
            this.updateObjective(objectives.prep3);
        }
        if(showResult){
            this.updaters.loadoutValidator(response);
        }
        return response;
    }
    /* Save & Load State Section */
    this.savePrepState = function() {
        const tileMapBackup = [];
        const loadout = [];
        for(let i = 0; i < this.tileMap.length; i++){
            tileMapBackup.push([]);
            for(let tile of this.tileMap[i]){
                tileMapBackup[i].push(tile.unit);
            }
        }
        this.currentPlacingUnits.forEach((entry) => {
            loadout.push({
                unit: entry.unit.id,
                count: entry.count
            });
        });
        localStorage.setItem('prepStageBackup', JSON.stringify({
            tileMap: tileMapBackup,
            loadout: loadout,
            allowHoverUnits: this.allowHoverUnits,
            allowAutoJump: this.allowAutoJump,
            placingUnit: this.placingUnit,
            gameId: this.gameId
        }));
    }
    this.loadPrepState = function() {
        const backup = localStorage.getItem('prepStageBackup');
        if(backup){
            const {tileMap, loadout, gameId, allowHoverUnits, allowAutoJump, placingUnit} = JSON.parse(backup);
            if(gameId === this.gameId || this.debug){
                for(let y = 0; y < tileMap.length; y++){
                    for(let x = 0; x < tileMap[y].length; x++){
                        if(tileMap[x][y]){
                            this.tileMap[x][y].unit = tileMap[x][y];
                        }
                    }
                }
                this.currentPlacingUnits = this.getStarterUnits(loadout, this.localTeam);
                this.placingUnit = placingUnit;
                this.allowHoverUnits = allowHoverUnits;
                this.allowAutoJump = allowAutoJump;
            }
            else{
                this.savePrepState();
            }
        }
        else{
            this.savePrepState();
        }
    }
    /* Server Section */
    this.renderTileMap = function() {
        const tileMap = [];
        let unit;
        for(let i = this.lowerHalfIndex; i < this.tileMap.length; i++){
            tileMap.push([]);
            for(let tile of this.tileMap[i]){
                unit = tile.unit;
                tileMap[i - this.lowerHalfIndex].push(unit ? unit.id : null);
            }
        }
        return tileMap;
    }
    this.serverHandlers = {
        tileMap(updater) {
            for(let entry of updater){
                const tile = that.getTileByLocation(...entry.cords);
                const ignore = entry.unit && entry.unit.team === that.localTeam && entry.unit.id !== 'flag';
                let unit;
                if(!ignore){
                    if(entry.unit){
                        unit = that.getUnitById(entry.unit.id)(entry.unit.team);
                        unit.isCarryingFlag = entry.unit.isCarryingFlag ? entry.unit.isCarryingFlag : false;
                        unit.badgeNumber = entry.unit.badgeNumber ? entry.unit.badgeNumber : 0;
                    }
                    tile.unit = unit;
                }
            }
            that.updateTileMap();
        },
        redDeadHall(updater) {
            for(let unitId of updater){
                that.addToDeadHall(that.getUnitById(unitId)('red'));
            }
        },
        blueDeadHall(updater) {
            for(let unitId of updater){
                that.addToDeadHall(that.getUnitById(unitId)('blue'));
            }
        },
        gameStage(updater) {
            that.gameStage = updater;
            that.updateGameStatus();
        },
        turnPlayer(updater) {
            that.turnPlayer = updater;
            that.updateGameStatus();
        },
        winner(updater){
            that.declareWinner(updater);
        }
    },
    this.handleServerUpdates = function(updater) {
        // Possible updates:
        // tileMap, redDeadHall, blueDeadHall, gameStage, turnPlayer
        log(updater);
        for(let entry in updater){
            const func = that.serverHandlers[entry];
            if(func){
                func(updater[entry]);
            }
        }
    }
    this.setReadyStatus = function(status) {
        if(status === undefined){
            status = !this.selfReady;
        }
        if(!status){
            if(this.selfReady){
                this.selfReady = false;
                this.socket.emit('game.setReadyStatus', false, null, () => {});
                this.updateObjective(objectives.prep3);
            }
        }
        else{
            const validation = this.validateLoadout();
            if(validation.accepted) { 
                this.socket.emit('game.setReadyStatus', true, this.renderTileMap(), (response) => {
                    log(response);
                    if(response.accepted){
                        this.selfReady = !this.selfReady;
                        if(this.gameStage === gameStages.prepStage){
                            this.updateObjective(objectives.prep4);
                        }
                    }
                });
            }
            else{
                this.updaters.loadoutValidator(validation);
            }
        }
    }
    this.setServerEvents = function() {
        this.socket.on('match.opponentReadyStatus', (status) => {
            this.opReady = status;
        });
        this.socket.on('match.updateGameData', this.handleServerUpdates);
    }
    this.makeMove = function(moveType, ...args) {
        // Backing up game's state in case of server move denial
        const actionFuncs = {
            move: that.moveUnit,
            load: that.loadUnit,
            unload: that.unloadUnit,
            attack: () => {},
        };
        const virtualUnitId = this.virtualUnitId;

        const actionFunc = actionFuncs[moveType];
        if (actionFunc){
            const stateBackup = {
                tileMap: JSON.parse(JSON.stringify(this.tileMap)),
                turnPlayer: this.turnPlayer
            };
            this.turnPlayer = this.localTeam === 'red' ? 'blue' : 'red';
            if(moveType !== 'attack'){
                actionFunc(...args);
            }
            this.updateGameStatus();
            const moveArgs = [...args];
            if(['load', 'unload'].includes(moveType)){
                moveArgs.push(virtualUnitId);
            }
            this.socket.emit('game.makeMove', {moveType, moveArgs}, (response) => {
                if(response.accepted){
                    if(response.gameUpdates){
                        if(moveType === 'attack'){
                            const winner = response.gameUpdates.tileMap[1];
                            if(winner && winner.unit && winner.unit.team === that.localTeam){
                                const cordsArr = [...args]; // [attackerXpos, attackerYpos, targetXpos, targetYpos]
                                const attacker = that.getUnitByLocation(cordsArr[0], cordsArr[1]);
                                if(winner.unit.isCarryingFlag){
                                    const flag = that.getUnitById('flag')(that.localTeam === 'red' ? 'blue' :'red');
                                    attacker.unitsCurrentlyLoaded.push(flag);
                                    attacker.isCarryingFlag = true;
                                }
                                that.placeUnit(cordsArr[2], cordsArr[3], attacker);
                                response.gameUpdates.tileMap.pop();
                            }
                        }
                        that.handleServerUpdates(response.gameUpdates);
                    }
                }
                else{
                    log('reverting')
                    that.tileMap = stateBackup.tileMap;
                    that.turnPlayer = stateBackup.turnPlayer;
                    that.updateTileMap();
                    that.hideAllPointers();
                    that.updateGameStatus();
                }
            });
        }
    }
    /* General Section */
    this.initTileMap = function() {
        that.tileMap = [];
        for(let i = 0; i < that.board.length; i++){
            that.tileMap.push([]);
            for(let j = 0; j < that.board[i].length; j++){
                let obj = {
                    groundType: that.board[i][j],
                    pointer: {enabled: false, color: 'none'},
                    unit: null,
                    showHoverUnit: false,
                    cords: [j, i]
                };
                that.tileMap[i].push(obj);
            }
        }
    }
    this.setGameSettings = function(gameSettings) {
        const { map, team, unitLoadout, flagBlockageLimit, gameStage } = gameSettings;
        that.gameStage = gameStages
        that.board = map;
        that.localTeam = team;
        that.flagBlockageLimit = flagBlockageLimit;
        that.unitLoadout = unitLoadout;
        that.currentPlacingUnits = that.getStarterUnits(unitLoadout, team);
        if(gameStage === gameStages.prepStage){
            this.opReady = gameSettings.opReady;
        }
    }
    this.onTileClick = function(tileXpos, tileYpos, clickType) {
        log(`Tile click on: (${tileXpos}, ${tileYpos})`);
        const tile = that.getTileByLocation(tileXpos, tileYpos);
        const unit = tile.unit;
        let unitCounter;
        if(that.gameStage === gameStages.prepStage){
            // If game stage is prep stage
            if(that.board.length - tileYpos < 10){
                // If the click is on the bottom 8 tile rows
                let modifiedTileMap = false;
                if(!unit && clickType === 'l'){
                    unitCounter =  that.currentPlacingUnits.find(val => val.unit.id === that.placingUnit);
                    // If the tile is empty and left clicked
                    if(unitCounter.count > 0){
                        // If there are enough units for placement
                        const unitToPlace = that.getUnitById(that.placingUnit)(that.localTeam);
                        if(unitToPlace.prepPlacements.includes(tile.groundType)){
                            // All conditions match --> Place a unit
                            that.placeUnit(tileXpos, tileYpos, unitToPlace);
                            unitCounter.count--;
                            that.updateUnitSelector();
                            modifiedTileMap = true;
                        }
                    }
                }
                else if(unit && ['r', 'm'].includes(clickType)){
                    // If the tile is populated and right clicked
                    unitCounter =  that.currentPlacingUnits.find(val => val.unit.id === unit.id);
                    that.hideUnit(tileXpos, tileYpos);
                    unitCounter.count++;
                    that.updateUnitSelector();
                    if(clickType === 'm'){
                        that.setPlacingUnit(unitCounter.unit.id);
                    }
                    modifiedTileMap = true;
                }
                if(modifiedTileMap){
                    that.hideAllPointers();
                    that.setReadyStatus(false);
                    if(that.allowAutoJump && unitCounter.count === 0){
                        that.autoJump()
                    }
                    that.updateObjective();
                    that.savePrepState();
                }
            }
        }
        else if(that.turnPlayer === that.localTeam){
            if(!that.selectMode){
                // If select mode isn't activated
                if(unit && unit.team === that.localTeam){
                    // If there is currently a unit on the tile, enable select mode
                    that.enableSelectMode(tileXpos, tileYpos); 
                }
            }
            else{
                // If select mode is enabled
                const cords = [tileXpos, tileYpos];
                let moveDone = false;
                for(let move of that.selectModeMoves){
                    if(arraysMatch(cords, move.cords)){
                        // If an active tile is clicked, the right move will be executed
                        that.makeMove(move.action, ...that.selectedUnitCords, tileXpos, tileYpos);
                        moveDone = true;
                        break;
                    }
                }
                if(!arraysMatch([tileXpos, tileYpos], that.selectedUnitCords)){
                    // If selected unit itself isn't clicked
                    that.disableSelectMode();
                    if(!moveDone && that.getUnitByLocation(tileXpos, tileYpos)){
                        // If player wants to switch focus to another unit
                        that.onTileClick(tileXpos, tileYpos);
                    }
                }
            }
        }
    }
    this.onKeyPress = function(e) {
        const cycleUp = [87, 68, 38, 39];
        const cycleDown = [83, 65, 40, 37];
        if(this.gameStage === gameStages.prepStage){
            if(cycleUp.includes(e.keyCode)){
                this.cycleUnitSelector(1);
            }
            else if(cycleDown.includes(e.keyCode)){
                this.cycleUnitSelector(-1);
            }
            else{
                switch(e.keyCode){
                    case 32: // Space
                        this.toggleHoverUnits();
                        break;
                    case 86: // V
                        this.validateLoadout(true);
                        break;
                    case 88: // X
                        this.toggleAutoJump();
                        break;
                    case 84: // T
                        if(!e.repeat){
                            this.setReadyStatus();   
                        }
                        break;
                    case 82: // R
                        this.reset();
                        break;
                    case 75: // K
                        break;
                }
            }
        }
    }
    this.reset = function() {
        if(this.gameStage === gameStages.prepStage){
            this.initTileMap();
            this.currentPlacingUnits = this.getStarterUnits(this.unitLoadout, this.localTeam);
            this.updateTileMap();
            this.updateUnitSelector();
            this.savePrepState();
        }
    }
    this.init = function(socket, gameId) {

        this.lowerHalfIndex = 11;
        this.debug = !config.production;

        this.selfReady = false;

        if(gameId){
            this.gameId = gameId;
        }
        this.socket = socket;
        this.gameStage = gameStages.prepStage;
        this.turnPlayer = 'red';
        this.turnNumber = 0;

        this.blueDeadHall = [];
        this.redDeadHall = [];
        
        this.selectedUnitCords = [];
        this.selectModeMoves = [];
        this.selectMode = false;
        this.virtualUnit = null;
        this.hoverUnit = null;
        this.virtualUnitId = -1;
        this.tileMap = [];
        this.initTileMap();

        this.placingUnit = units.corporalTroopObject().id;
        
        this.allowNestedVehicles = false;
        this.allowHoverUnits = true;
        this.allowAutoJump = true;

        if(this.gameStage === gameStages.prepStage){
            this.loadPrepState();
        }

        this.updateObjective();

        this.disableSelectMode();
        this.updaters.deadHall('red', this.redDeadHall);
        this.updaters.deadHall('blue', this.blueDeadHall);
        // Setting server events
        this.setServerEvents();
    }

    this.updaters = {};
}